import React, { useState, useEffect } from 'react';
import axios from "axios"

function MainSectionRice() {
    const [monthlyArticleCount, setMonthlyArticleCount] = useState(0);
    const [affectedAreaCount, setAffectedAreaCount] = useState(0);

    useEffect(() => {
        fetch('https://disease.scnu.ac.kr/riceblast/period')
            .then(response => response.json())
            .then(data => {
                setMonthlyArticleCount(data.count);
            })
            .catch(error => console.error('Fetch error:', error));
    }, []);

    useEffect(() => {
        // 피해 및 피해 예상 지역 갯수를 가져오는 API 호출
        axios.get('https://disease.scnu.ac.kr/riceblastlocation/period')
            .then(res => {
                setAffectedAreaCount(res.data.length);
            })
            .catch(err => {
                console.error('Axios error:', err);
            });
    }, []);

    return(
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 mb-6">
            <div className="card">
                <div className="card-content">
                    <div className="flex items-center justify-between">
                        <div className="widget-label">
                            <h3>
                                한 달간 기사 갯수
                            </h3>
                            <h1>{monthlyArticleCount}</h1>
                        </div>
                        <span className="icon widget-icon text-blue-500"><i
                            className="mdi mdi-newspaper-variant-multiple-outline mdi-48px"></i></span>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="card-content">
                    <div className="flex items-center justify-between">
                        <div className="widget-label">
                            <h3>
                                1년간 피해 지역 (시군구 기준)
                            </h3>
                            <h1>{affectedAreaCount}</h1>
                        </div>
                        <span className="icon widget-icon text-red-500"><i
                            className="mdi mdi-alert-octagon mdi-48px"></i></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainSectionRice;
